var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "16px", display: "flex" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.new-user-modal",
                  modifiers: { "new-user-modal": true }
                }
              ],
              staticClass: "mr-1",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "align-items": "center"
              }
            },
            [
              _c("i", {
                staticClass: "p-0 fa fa-plus",
                staticStyle: { "margin-right": "8px" }
              }),
              _vm._v(" Añadir usuario\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "ml-1",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "align-items": "center"
              },
              on: { click: _vm.exportar }
            },
            [
              _c("i", {
                staticClass: "p-0 fa fa-download",
                staticStyle: { "margin-right": "8px" }
              }),
              _vm._v(" Exportar a XLS\n    ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c("v-server-table", {
            ref: "users-table",
            staticClass: "table-hide-nativetoggler",
            attrs: {
              url: "lista-usuarios/",
              columns: _vm.columns,
              options: _vm.options
            },
            scopedSlots: _vm._u([
              {
                key: "last_login",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        " " + _vm._s(_vm._f("formatDate")(props.row.last_login))
                      )
                    ])
                  ])
                }
              },
              {
                key: "is_active",
                fn: function(props) {
                  return _c("div", {}, [
                    props.row.is_active
                      ? _c("span", [_vm._v("Si")])
                      : _c("span", [_vm._v("No")])
                  ])
                }
              },
              {
                key: "actions",
                fn: function(props) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("ActionsUser", {
                        attrs: { data: props.row, index: props.index }
                      })
                    ],
                    1
                  )
                }
              },
              {
                key: "child_row",
                fn: function(props) {
                  return _vm.options.details ? undefined : undefined
                }
              }
            ])
          })
        : _vm._e(),
      _vm._v(" "),
      _c("NewUser", {
        attrs: { permisos: _vm.permisos },
        on: { "update-users-list": _vm.updateUsersList }
      }),
      _vm._v(" "),
      _c("EditUser", {
        key: _vm.selectedUser.id,
        attrs: { permisos: _vm.permisos, user: _vm.selectedUser },
        on: { "update-users-list": _vm.updateUsersList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/users-management/users-list/UsersList.vue?vue&type=template&id=de7039ee&
// module id = null
// module chunks = 